import React from 'react';
import {Drawer, Button} from 'antd';

const reloadWindow = () => {
    window.location.reload();
};

export default () => {

    return <Drawer
        title="Your app is out of date."
        placement="top"
        closable={false}
        visible={true}
    >
        <div style={{textAlign: 'center'}}>
            <h3>
                Reload your app now to get the latest and greatest version.
            </h3>
        </div>
        <h2>
            <p style={{textAlign: 'center'}}>
                <Button type="primary" icon="redo" size='large' onClick={reloadWindow}>
                    Reload
                </Button>
            </p>
        </h2>
    </Drawer>;
};
